import { getStatusBarHeight } from 'utils/tool.js'
import { getOffsetTop } from 'lib/tools/domUtil.js'

/**
 * homepage存在大量的动态计算，将其抽取为一个mixin
 */
export default {
  data() {
    return {
      mixinMaskTop: '16rem',
      mixinShowZxTabsDistance: 0,
      mixinShowQsTabsDistance: 0
    }
  },
  computed: {
    distance() {
      return this.$store.state.homepage.distance
    },
    currentTab() {
      return this.$store.state.homepage.currentTab
    }
  },
  mounted() {
    this.calcHeights()
    this.calcMaskTop()
  },
  methods: {
    async calcMaskTop() {
      await this.$nextTick()
      const inner = document.querySelector('#js-content-inner')
      if (inner) {
        this.mixinMaskTop = getOffsetTop(inner) + 30 + 'px'
      }
    },
    // 页面挂载 or 接口请求成功后 需动态计算一些高度
    async calcHeights() {
      await this.$nextTick()
      await this._getStatusBarHeight()
      this._getHeaderAndTabHeight()
      this._getZxTabsDistance()
      this._getQsTabsDistance()
    },
    // 页面重绘后续做的操作放这里。延迟个300毫秒触发。
    mixinUpdateHeight() {
      this.calcMaskTop()
      this.calcHeights()
    },
    // App内状态栏高度
    _getStatusBarHeight() {
      return new Promise(resolve => {
        const { isYixinliApp, isZiXunApp } = this.$platform
        if (isYixinliApp || isZiXunApp) {
          getStatusBarHeight()
            .then(h => {
              console.info('statusBarHeight:', h)
              this.$store.commit('homepage/SET_DISTANCE', {
                statusbarHeight: h
              })
              resolve()
            })
            .catch(() => {
              resolve()
            })
        } else {
          resolve()
        }
      })
    },
    // 最顶部header栏高度 和 两个tab栏的高度
    _getHeaderAndTabHeight() {
      const { Header, Tabbar } = this.$refs
      if (Header) {
        const mh = Header.getMobileHeaderRef()
        this.$store.commit('homepage/SET_DISTANCE', {
          headerHeight: mh.$el.offsetHeight
        })
      }
      const tabbar = Tabbar.$el
      if (tabbar) {
        const oh = tabbar.offsetHeight
        this.$store.commit('homepage/SET_DISTANCE', {
          navHeight: oh,
          zxNavHeight: oh
        })
      }
    },
    // 计算什么时候显示第二层tab
    _getZxTabsDistance() {
      const { ServiceList } = this.$refs
      if (!ServiceList || typeof ServiceList.getRefs !== 'function') return

      const refs = ServiceList.getRefs()
      if (!refs || !refs.length) return
      const elem = refs[0].$el

      this.mixinShowZxTabsDistance =
        getOffsetTop(elem) -
        this.distance.headerHeight -
        this.distance.navHeight -
        this.distance.zxNavHeight
    },
    _getQsTabsDistance() {
      const { QsServiceList } = this.$refs
      if (!QsServiceList || typeof QsServiceList.getRefs !== 'function') return
      const refs = QsServiceList.getRefs()
      if (!refs || !refs.length) return
      const elem = refs[0].$el
      this.mixinShowQsTabsDistance =
        getOffsetTop(elem) -
        this.distance.headerHeight -
        this.distance.navHeight -
        this.distance.zxNavHeight
    }
  }
}
